export default __webpack_public_path__ + "static/media/img3.78af476b.jpg";